import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IBox } from '../../document-type-settings.dto';

@Component({
  selector: 'app-default-box',
  templateUrl: './default-box.component.html',
  styleUrl: './default-box.component.scss'
})
export class DefaultBoxComponent {
  
  @Output() updateVisibility = new EventEmitter<{boxIndex: number, isVisible: boolean}>();

  @Input() box: IBox;
  @Input() boxIndex: number;



  updateBoxStatus(status: boolean): void {
    this.updateVisibility.emit({ boxIndex: this.boxIndex, isVisible: status });  
  }
}
